import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { AxiosPrivado, AxiosPublico } from "../../componentes/axios/Axios";
import { ClientesGuardar2, UsuarioIniciarSesion } from "../../configuracion/apiUrls";
import { mostraAlerta } from "../alerts/sweetAlert";
import { useContextUsuario } from "../../contexto/usuario/UsuarioContext";
import { IdentificarEstacion } from "../../componentes/estacion/Estacion";
const GOOGLE_CLIENT_ID = "195516590670-e1kd3vbfgju73bnlansnqf5juslnkmub.apps.googleusercontent.com";
// Función para desglosar el nombre completo
const descomponerNombre = (nombreCompleto) => {
    if (!nombreCompleto) return { primerNombre: '', segundoNombre: '', primerApellido: '', segundoApellido: '' };

    const partes = nombreCompleto.trim().split(/\s+/).filter(p => p.length > 0);
    const result = {
        primerNombre: partes[0] || '',
        segundoNombre: partes.length > 2 ? partes[1] : '',
        primerApellido: partes.length > 1 ? (partes.length === 2 ? partes[1] : partes[partes.length - 2]) : '',
        segundoApellido: partes.length > 3 ? partes[partes.length - 1] : (partes.length === 2 ? '' : partes[partes.length - 1]),
    };

    // Simplificación para 4 o más partes (ejemplo: "Juan Fernando Pérez López")
    if (partes.length >= 4) {
        result.primerNombre = partes[0];
        result.segundoNombre = partes[1];
        result.primerApellido = partes[2];
        result.segundoApellido = partes[3];
    } else if (partes.length === 3) { // Ejemplo: "Juan Pérez López"
        result.primerNombre = partes[0];
        result.segundoNombre = '';
        result.primerApellido = partes[1];
        result.segundoApellido = partes[2];
    }

    return result;
};

const IniciarRegistroGoogle = ({ onRegistrationSuccess }) => {
    return (
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <RegistroGoogle onRegistrationSuccess={onRegistrationSuccess} />
        </GoogleOAuthProvider>
    );
};

const RegistroGoogle = ({ onRegistrationSuccess }) => {
    const navigate = useNavigate();
    const { setLogin } = useContextUsuario();

    const handleGoogleLoginSuccess = async (credentialResponse) => {
        try {
            if (!credentialResponse || !credentialResponse.access_token) {
                throw new Error("Token de Google no recibido");
            }

            const response = await fetch(
                `https://www.googleapis.com/oauth2/v3/userinfo`,
                {
                    headers: {
                        Authorization: `Bearer ${credentialResponse.access_token}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Error al obtener datos del usuario desde Google");
            }

            const userInfo = await response.json();
            const { name, email, given_name, family_name } = userInfo;

            if (!email) {
                mostraAlerta("Se requiere el permiso de correo para el registro.", "warning");
                return;
            }

            let primerNombre = given_name || '';
            let primerApellido = family_name || '';
            let segundoNombre = '';
            let segundoApellido = '';

            // Si falta alguno, intentamos analizar el nombre completo
            if (!given_name || !family_name) {
                const nombresAnalizados = descomponerNombre(name);

                // Usamos los nombres analizados solo si los proporcionados por Google están incompletos
                primerNombre = primerNombre || nombresAnalizados.primerNombre;
                segundoNombre = nombresAnalizados.segundoNombre;
                primerApellido = primerApellido || nombresAnalizados.primerApellido;
                segundoApellido = nombresAnalizados.segundoApellido;
            }

            const registrationData = {
                nombre: name,
                correo: email,
                primerNombre: primerNombre,
                segundoNombre: segundoNombre,
                primerApellido: primerApellido,
                segundoApellido: segundoApellido,
                tipoUsuario: "Cliente",
                imagen: "clientes.jpeg",
            };
            try {
                await AxiosPrivado.post(ClientesGuardar2, registrationData);

                try {
                    const loginResponse = await AxiosPublico.post(UsuarioIniciarSesion, {
                        login: email,
                        isGoogleLogin: true,
                    });

                    const { Usuario: usuario, Token: token } = loginResponse.data;

                    mostraAlerta(`Bienvenido(a) ${usuario.datoPersonales.nombreCompleto}`, "success");
                    await setLogin({ usuario, token });
                    await IdentificarEstacion();

                    if (onRegistrationSuccess) {
                        onRegistrationSuccess();
                    }
                    navigate("/app/clientes/");

                } catch (loginError) {
                    console.error("Error en auto-login Google:", loginError);
                    mostraAlerta("Usuario registrado, pero falló el inicio de sesión automático. Por favor inicia sesión manualmente.", "warning");
                    navigate("/login");
                }

            } catch (registrationError) {
                console.error("Error en el registro con Google:", registrationError);
                let errorMessage = "Error al registrar el cliente. Intenta nuevamente.";

                if (registrationError.response && registrationError.response.data) {
                    const data = registrationError.response.data;
                    if (Array.isArray(data)) {
                        errorMessage = data.map(e => e.msg).join(". ");
                    } else if (data.error) {
                        errorMessage = data.error;
                    }
                }
                mostraAlerta(errorMessage, "error");
            }

        } catch (error) {
            console.error("Error al procesar el registro con Google:", error);
            mostraAlerta("Error al procesar el registro con Google", "error");
        }
    };

    const handleGoogleLoginFailure = () => {
        mostraAlerta("Error al iniciar sesión con Google", "error");
    };

    const googleLogin = useGoogleLogin({
        onSuccess: handleGoogleLoginSuccess,
        onError: handleGoogleLoginFailure,
        flow: "implicit",
    });

    return (
        <button
            type="button"
            className="btn btn-block btn-lg mt-2"
            style={{ backgroundColor: '#DB4437', color: 'white' }}
            onClick={googleLogin}
        >
            <i className="fab fa-google mr-2"></i> Registrarse con Google
        </button>
    );
};

export default IniciarRegistroGoogle;